<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    :title="$t('role.roleIssue')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    width="800px"
  >
    <el-form
      ref="formRef"
      label-position="top"
      :rules="formRules"
      :model="formData"
    >
      <el-form-item :label="$t('orgManage.orgName')" prop="orgData">
        <edmSelect
          v-model="formData.orgData"
          class="w100"
          :multiple="true"
          :filterable="true"
          :remote="true"
          :clearable="true"
          :placeholder="$t('common.pleaseChoose')"
          :select-data="orgList"
          @loadMore="getList"
        >
          <template v-for="(item) in orgList">
            <el-option v-show="!item.hidden" :key="`${item.id}_${item.hidden}`" :label="item.orgName" :value="item.id"></el-option>
          </template>
        </edmSelect>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">
        {{ $t("public.confirm") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import orgManageApi from "@/api/orgManage";
import roleApi from "@/api/role/role";
import edmSelect from "@/components/private/edm-select";
import { mapGetters } from "vuex";
export default {
  name: "RoleIssueOrg",
  components: {
    edmSelect
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      formKey: new Date().getTime(),
      formData: {
        orgData: []
      },
      formRules: {
        orgData: [
          {
            required: true,
            message: `${this.$t("common.pleaseChoose")}${this.$t("orgManage.orgName")}`,
            trigger: "change"
          }
        ]
      },
      loading: false,
      orgList: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    ...mapGetters(["tenantId"])
  },
  created() {
  },
  methods: {
    // 获取组织列表数据
    getList({ pagination = {}, searchValue = "", restData = false }) {
      if (restData) { this.workTechList = []; }
      const params = {
        page: pagination.pageNum,
        size: pagination.pageSize,
        tenantId: this.tenantId,
        search: searchValue
      };
      orgManageApi.getList(params).then(res => {
        const { data } = res;
        if (data) {
          const { records = [], total = 0 } = data;
          this.orgList = records;
          pagination.total = Number(total);
        }
      });
    },
    // 确认提交
    handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.loading = true;
          const params = {
            orgIds: this.formData.orgData,
            roleIds: [this.propData.id]
          };
          roleApi.issueToOrgApi(params).then(res => {
            this.loading = false;
            if (res.success) {
              this.$message.success(this.$t("common.issue") + this.$t("common.success"));
              this.dialogVisible = false;
              this.$emit("refresh");
            }
          }, () => {
            this.loading = false;
          });
        }
      });
    },
    // 新增|编辑成功后回调
    successCallback(res, isAdd) {
      this.loading = false;
      if (res) {
        this.$message.success(this.$t(`${isAdd ? "common.addSuccess" : "common.editSuccess"}`));
        this.dialogVisible = false;
        this.$emit("refresh", true);
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
